export function MobileContainer ({children})
{
    return(
        <div style={{minHeight:"100%", height:"100%", 
        width:"100%", minWidth:"100%", 
        maxHeight:"100%", maxWidth:"100%",
        /*display: "flex", justifyContent:"center", 
        alignItems:"center", overflow:"hidden",*/
        }}>
            {children}
        </div>
    );
}